module.exports = __webpack_public_path__ + "static/media/title_18.ace0c0c9.svg";